export default __webpack_public_path__ + "/assets/xlsx_big.png";